import { message } from 'antd';

type props = {
  res: any;
  onSuccess(_res: any): void;
  dataOnly?: boolean;
  notifSuccess?: boolean | string;
  notifFail?: boolean;
  onFailed?: () => void;
  setLoading?: (_loading: boolean) => void;
};

export const handleApiThen = ({ res, onSuccess, dataOnly = false, notifSuccess = false, notifFail = true, onFailed, setLoading }: props) => {
  if (res.isSuccess) {
    if (notifSuccess) {
      const resMessage = typeof notifSuccess === 'string' ? notifSuccess : 'عملیات با موفقیت انجام شد.';
      message.success(resMessage);
    }
    onSuccess(dataOnly ? res.data : res);
  } else {
    notifFail && res?.message && message.warning(res?.message);
    onFailed && onFailed();
  }
  setLoading && setLoading(false);
};

interface genericProps<T, D> {
  res: T & { isSuccess?: boolean; message?: string; data: D };
  onSuccess?: (_res: T) => void;
  onSuccessData?: (_data: D) => void;
  notifSuccess?: boolean;
  notifFail?: boolean;
  onFailed?: (_error?: any) => void;
  setLoading?: (_a: boolean) => void;
}

export const handleApiThenGeneric = <T, D>({ res, onSuccess, onSuccessData, notifSuccess = false, notifFail = true, onFailed, setLoading }: genericProps<T, D>) => {
  if (res.isSuccess) {
    if (notifSuccess) {
      const resMessage = typeof notifSuccess === 'string' ? notifSuccess : 'عملیات با موفقیت انجام شد.';
      message.success(resMessage);
    }
    onSuccess && onSuccess(res);
    onSuccessData && onSuccessData(res.data);
  } else {
    notifFail && res?.message && message.warning(res?.message);
    onFailed && onFailed();
  }
  setLoading && setLoading(false);
};
